import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router";
import { AuthLayout } from "../components/AuthLayout";
import { ErrorNotice, Field, useAction } from "../components/ui";
import { api } from "../lib/api";
import { LEGAL_VERSION } from "../lib/config";
import { pendingInvite, useSession } from "../lib/session";

/** Logged in, but not in a company yet: start one (or go back to a pending invite). */
export function Setup() {
  const navigate = useNavigate();
  const { refresh, signOut } = useSession();
  const { pending, error, run } = useAction();
  const [name, setName] = useState("");
  const [yourName, setYourName] = useState("");
  const [accepted, setAccepted] = useState(false);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    void run(async () => {
      await api.signup(name.trim(), yourName.trim(), LEGAL_VERSION);
      await refresh();
      navigate("/team", { replace: true });
    });
  };

  return (
    <AuthLayout
      masthead={
        <h1 className="display">
          Open the <em>books</em>.
        </h1>
      }
    >
      <form className="form" onSubmit={submit}>
        <div className="page-head">
          <h2 className="title">
            Name your <em>company</em>
          </h2>
          <p className="lede">You'll be its owner. You can invite consultants next.</p>
        </div>
        <Field
          label="Your name"
          hint="What your colleagues see, instead of your email."
          autoComplete="name"
          required
          maxLength={80}
          autoFocus
          value={yourName}
          onChange={(e) => setYourName(e.target.value)}
          placeholder="e.g. Sam Smith"
        />
        <Field
          label="Company name"
          autoComplete="organization"
          required
          maxLength={200}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Smith Talent Ltd"
        />
        <label className="check">
          <input type="checkbox" required checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
          <span>
            I accept the{" "}
            <Link to="/legal/terms" target="_blank">
              terms of service
            </Link>{" "}
            and{" "}
            <Link to="/legal/dpa" target="_blank">
              data processing agreement
            </Link>{" "}
            for this company, and have read the{" "}
            <Link to="/legal/privacy" target="_blank">
              privacy policy
            </Link>
            .
          </span>
        </label>
        <ErrorNotice error={error} />
        <button className="btn block" disabled={pending || !accepted}>
          {pending ? "Setting up…" : "Create company"}
        </button>
        <p className="sheet-foot">
          {pendingInvite.get() ? (
            <>
              Joining a team instead? <Link to="/join">Back to your invitation</Link>
            </>
          ) : (
            <>
              Were you invited? Open the link from your invitation.{" "}
              <button type="button" className="link-btn" onClick={() => void signOut()}>
                Sign out
              </button>
            </>
          )}
        </p>
      </form>
    </AuthLayout>
  );
}
